export default "__VITE_ASSET__14c3098e__"